import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, projectExpenseType }) =>
    present(
      repository
        .saveProjectExpenseType(planzone, projectExpenseType)
        .then((savedProjectExpenseType) => ({
          planzone,
          projectExpenseType: savedProjectExpenseType,
        }))
        .catch(() =>
          Promise.reject({
            planzone,
            projectExpenseType,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
